var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _vm.showGeneral
      ? _c(
          "div",
          { staticClass: "d-flex justify-content-between align-items-center" },
          [
            _c("div", [
              _c("strong", [_vm._v(_vm._s(_vm.name))]),
              _vm._v(" "),
              _c("span", { staticClass: "badge badge-secondary ml-2" }, [
                _vm._v(
                  "\n        " +
                    _vm._s(
                      _vm.$te(
                        "workflow.vueFormBuilder.elements.general.types." +
                          _vm.type
                      )
                        ? _vm.$t(
                            "workflow.vueFormBuilder.elements.general.types." +
                              _vm.type
                          )
                        : _vm.$t(
                            "workflow.vueFormBuilder.elements.general.types.unknown"
                          )
                    ) +
                    "\n      "
                )
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "btn-group" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-sm btn-outline-secondary",
                  on: {
                    click: function($event) {
                      return _vm.$emit("toggleCollapse")
                    }
                  }
                },
                [_c("Chevron", { attrs: { down: _vm.collapsed } })],
                1
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "btn btn-sm btn-danger",
                  on: {
                    click: function($event) {
                      return _vm.$emit("remove")
                    }
                  }
                },
                [_c("i", { staticClass: "fa fa-trash-alt" })]
              )
            ])
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    !_vm.collapsed
      ? _c(
          "div",
          [
            _vm.showGeneral
              ? _c("div", { staticClass: "form-row" }, [
                  _c("div", { staticClass: "form-group col-md-4" }, [
                    _c("label", [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "workflow.vueFormBuilder.elements.general.model.label"
                          )
                        )
                      )
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.label,
                          expression: "label"
                        }
                      ],
                      staticClass: "form-control",
                      domProps: { value: _vm.label },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) return
                          _vm.label = $event.target.value
                        }
                      }
                    })
                  ]),
                  _vm._v(" "),
                  _vm.type === "text" || _vm.type === "textarea"
                    ? _c("div", { staticClass: "form-group col-md-4" }, [
                        _c("label", [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "workflow.vueFormBuilder.elements.text.model.placeholder"
                              )
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.placeholder,
                              expression: "placeholder"
                            }
                          ],
                          staticClass: "form-control",
                          domProps: { value: _vm.placeholder },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) return
                              _vm.placeholder = $event.target.value
                            }
                          }
                        })
                      ])
                    : _vm.type === "date"
                    ? _c("div", { staticClass: "form-group col-md-4" }, [
                        _c("label", [
                          _vm._v(
                            _vm._s(
                              _vm.$t(
                                "workflow.vueFormBuilder.elements.date.model.displayFormat"
                              )
                            )
                          )
                        ]),
                        _vm._v(" "),
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.displayFormat,
                              expression: "displayFormat"
                            }
                          ],
                          staticClass: "form-control",
                          attrs: {
                            placeholder: _vm.$t(
                              "workflow.vueFormBuilder.elements.general.displayFormatExample"
                            )
                          },
                          domProps: { value: _vm.displayFormat },
                          on: {
                            input: function($event) {
                              if ($event.target.composing) return
                              _vm.displayFormat = $event.target.value
                            }
                          }
                        })
                      ])
                    : _c("div", { staticClass: "form-group col-md-4" }),
                  _vm._v(" "),
                  _c("div", { staticClass: "form-group col-md-4" }, [
                    _c("label", [
                      _vm._v(
                        _vm._s(
                          _vm.$t(
                            "workflow.vueFormBuilder.elements.general.model.info"
                          )
                        )
                      )
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.info,
                          expression: "info"
                        }
                      ],
                      staticClass: "form-control",
                      domProps: { value: _vm.info },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) return
                          _vm.info = $event.target.value
                        }
                      }
                    })
                  ])
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.type === "static"
              ? _c("ElementStaticExtra", {
                  attrs: { builderElement: _vm.builderElement }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.type === "file"
              ? _c("ElementFileExtra", {
                  attrs: { builderElement: _vm.builderElement }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.type === "list"
              ? _c("ElementListExtra", {
                  attrs: { builderElement: _vm.builderElement }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.type === "date"
              ? _c("ElementDateExtra", {
                  attrs: { builderElement: _vm.builderElement }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.type === "object"
              ? _c("ElementObjectExtra", {
                  attrs: { builderElement: _vm.builderElement }
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.type === "text"
              ? _c("ElementTextExtra", {
                  attrs: { builderElement: _vm.builderElement }
                })
              : _vm._e()
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }